/**
     * @desc 查询上架手续费
用于上架时，查询上架的手续费数值和手续费单位
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, options = {}) {
  return ajax.post('/trading/getFee', params);
}

export function upload(params, options = {}) {
  return ajax.upload('/trading/getFee', params);
}
